// eslint-disable-next-line import/no-cycle
import { NavBarResponseTO } from "@/models/common/common";
import { HomeResponseTO } from "@/models/home";
// eslint-disable-next-line import/no-cycle
import { OpenGraph } from "next-seo/lib/types";

export interface IStructuredData {
    tourName?: string;
    description?: string;
    imageUrl?: string;
    category?: string;
    brand?: string;
    price?: number;
    currency?: string;
    availability?: string;
    bookingUrl?: string;
    averageRating?: number;
    reviewCount?: number;
}

export interface IMetadata {
    title: string;
    metaDescription: string;
    urlCanonical: string;
    altHeadImage?: string;
    altPreviewImageVideo?: string;
    altStepperImage?: string;
    altWhatWillYouSeeImage?: string;
    index?: boolean;
    structuredData?: IStructuredData;
}

export const getOpenGraphData = (
    homeData?: HomeResponseTO,
    navBarData?: NavBarResponseTO,
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    italianStoriesData?: any
): OpenGraph => {
    if (homeData && navBarData && italianStoriesData) {
        return {
            title: homeData.staticMedia?.metadata?.title,
            description: homeData.staticMedia?.metadata?.metaDescription,
            url: homeData.staticMedia?.metadata?.urlCanonical,
            images: [
                {
                    url: homeData.staticMedia?.headImage,
                    alt: homeData.staticMedia?.metadata?.altHeadImage,
                },
                {
                    url: homeData.staticMedia?.stepperImage,
                    alt: homeData.staticMedia?.metadata?.altStepperImage,
                },
                {
                    url: homeData.staticMedia?.previewImageVideo,
                    alt: homeData.staticMedia?.metadata?.altPreviewImageVideo,
                },
                ...(navBarData?.toursHome
                    .map(tourHome => tourHome?.tours)
                    .flat()
                    .map(tour => ({
                        url: tour?.image || "",
                        alt: tour?.metadata?.altHeadImage || "",
                    })) || []),
                ...(navBarData?.toursByDestination
                    .map(tourByDestination => tourByDestination?.tours)
                    .flat()
                    .map(tour => ({
                        url: tour?.image || "",
                        alt: tour?.metadata?.altHeadImage || "",
                    })) || []),
                /* eslint-disable  @typescript-eslint/no-explicit-any */
                ...italianStoriesData.map(
                    (blog: {
                        coverImage: any;
                        metadata: { altHeadImage: any };
                    }) => ({
                        url: blog.coverImage,
                        alt: blog?.metadata?.altHeadImage,
                    })
                ),
            ],
        };
    }
    return {};
};

export const getOpenGraphDataItalianStories = (
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    italianStoryData?: any,
    italianStoriesData?: any
): OpenGraph => {
    if (italianStoryData && italianStoriesData) {
        return {
            title: italianStoryData?.metadata?.title,
            description: italianStoryData?.metadata?.metaDescription,
            url: italianStoryData?.metadata?.urlCanonical,
            images: [
                {
                    url: "https://images.unsplash.com/photo-1583855282680-6dbdc69b0932?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3000&q=80",
                    alt: italianStoryData?.metadata?.altHeadImage,
                },
                ...italianStoriesData.map(
                    (blog: {
                        coverImage: any;
                        metadata: { altHeadImage: any };
                    }) => ({
                        url: blog.coverImage,
                        alt: blog?.metadata?.altHeadImage,
                    })
                ),
            ],
        };
    }
    return {};
};

export const getOpenGraphDataTourDestinations = (
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    toursShopPageData?: any,
    packageData?: any
): OpenGraph => {
    if (toursShopPageData && packageData) {
        return {
            title: toursShopPageData?.toursShopPage?.metadata?.title,
            description:
                toursShopPageData?.toursShopPage?.metadata?.metaDescription,
            url: toursShopPageData?.toursShopPage?.metadata?.urlCanonical,
            images: [
                {
                    url: "/images/search-head.webp",
                    alt: toursShopPageData?.toursShopPage?.metadata
                        ?.altHeadImage,
                },
                ...packageData.map((tour: any) => ({
                    url: tour.quality.image,
                    alt: tour?.metadata?.altHeadImage,
                })),
            ],
        };
    }
    return {};
};
